export default {
  data() {
    return {
      log: false,
    }
  },
  methods: {
    debugMsg() {
      if (this.log){
        let i, args = [];
        for (i = 0; i < arguments.length; i++) {
          args[i] = arguments[i];
        }
        console.log(args.join(' '))
      }
    }
  }
}
